import { SetupContext } from "@vue/composition-api";

export const hexColorToRGB = (v:string) => {
	if(v[0] === "#"){
		v = v.substr(1, v.length - 1);
	}
	var parsed = v.match(/.{1,2}/g);
	if(!parsed){ return null; }
	return {
		r:parseInt(parsed[0], 16),
		g:parseInt(parsed[1], 16),
		b:parseInt(parsed[2], 16)
	}
};

export const getColorBrightnessRGB = (c:{ r:number, g:number, b:number }) => {
	return Math.sqrt(
		c.r * c.r * .241 +
		c.g * c.g * .691 +
		c.b * c.b * .068
	) / 255;
};

export const getInverseHexColor = (v:string) => {
	const c = hexColorToRGB(v);
	if(!c){ return "black"; }
	const b = getColorBrightnessRGB(c);
	if(b > 0.5){
		return "black";
	}
	return "white";
};


export const setQueryValue = (k:string, v:any, context:SetupContext) => {
	const q:any = { ...context.root.$route.query };
	if(v !== undefined && v !== null){
		q[k] = v;
	}
	else {
		delete q[k];
	}
	context.root.$router.push({ query: q})
	.catch(() => {});
};


export const getQueryValue = <T>(k:string, context:SetupContext, def:T):T => {
	return ((context.root.$route.query[k] as any) as T) || def;
};